/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Tags_Color_HintInputs */

const cs_clients_tags_color_hint = /** @type {(inputs: Clients_Tags_Color_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volitelná CSS barva (např. #3b82f6).`)
};

const en_clients_tags_color_hint = /** @type {(inputs: Clients_Tags_Color_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional CSS color (e.g. #3b82f6).`)
};

/**
* | output |
* | --- |
* | "Optional CSS color (e.g. #3b82f6)." |
*
* @param {Clients_Tags_Color_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tags_color_hint = /** @type {((inputs?: Clients_Tags_Color_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tags_Color_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tags_color_hint(inputs)
	return cs_clients_tags_color_hint(inputs)
});